import styled from "styled-components";
import { rem, em } from "convert-to-ems";

export const CenteredElement = styled.div`
  width: 100%;
  text-align: center;
  text-align: -webkit-center;
`;

export const LogoImgElement = styled.img`
  margin-bottom: ${props => rem(props.logoMarginBottom)};
  margin-top: ${props => rem(props.logoMarginTop)};
  ${props => (props.logoWith ? `width: ${rem(props.logoWith)}` : "")};
  ${props => (props.logoHeight ? `height: ${rem(props.logoHeight)}` : "")};
`;

export const TitleElement = styled.p`
  font-family: ${props => props.theme.baseFontFamily};
  margin-bottom: ${props => rem(props.titleMarginBottom)};
  max-width: ${props => rem(props.titleMaxWidth)};
  font-weight: 500;
  line-height: ${rem(24)};
  color: black;
  ${props => (props.tittleFontSize ? `font-size: ${em(props.tittleFontSize)}` : "")};

  @media (${props => props.theme.breakpoints.medium}) {
    font-size: ${props => em(props.titleFontSizeMedium)};
    max-width: ${props => rem(props.titleMaxWidthMedium)};
  }
`;
